import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Flex } from 'rebass';
import { Form, Input } from 'formsy-semantic-ui-react';
import { Label } from 'semantic-ui-react';
import { CircularProgress } from '@material-ui/core';
import debounce from 'lodash/debounce';
import styled from 'styled-components';

import { FONT_SIZE, SPACE, COLOR } from '../Theme';
import { Text, Link, Icon } from '../Base';

import { errorLabel } from 'Util/form';

const Wrapper = styled(Box)`
  width: 100%;
  max-width: 460px;
  margin: 0 auto;
`;

class RedeemForm extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }
  static propTypes = {
    onSubmit: PropTypes.func,
    onClickLink: PropTypes.func,
    onOverviewClick: PropTypes.func,
    onRedeemSuccess: PropTypes.func,
    onRedeemUsed: PropTypes.func,
    errorText: PropTypes.string,
    landing: PropTypes.bool,
  };

  static defaultProps = {
    onSubmit: () => {},
    onClickLink: () => {},
    onOverviewClick: () => {},
    onRedeemSuccess: () => {},
    onRedeemUsed: () => {},
    errorText: 'เกิดข้อผิดพลาด กรุณาตรวจสอบรหัสอีกครั้ง',
  };

  state = {
    formChanged: false,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (
      (!prevProps.result || (prevProps.result && !prevProps.result.success)) &&
      this.props.result &&
      this.props.result.success
    ) {
      // console.log('form reset');
      setTimeout(() => {
        this.props.onRedeemSuccess();
        this.form.current.reset();
      }, 3000);
    } else if (
      this.props.result &&
      !this.props.result.success &&
      this.props.result.subCode === 'USED'
    ) {
      setTimeout(this.props.onRedeemUsed, 200);
      // this.form.current.reset();
    }
  };

  handleFormChange = (values, isChanged) => {
    this.setState({ formChanged: isChanged });
  };

  handleSubmit = debounce(
    formData => {
      this.props.onSubmit(formData);
      this.setState({ formChanged: false });
    },
    1000,
    { leading: true, trailing: false },
  );

  render() {
    const {
      onClickLink,
      onOverviewClick,
      disabled,
      defaultValue,
      result,
      errorText,
      landing,
    } = this.props;
    const { formChanged } = this.state;

    let resultMessage = <Text>&nbsp;</Text>;
    if (result && !formChanged) {
      const { success, message } = result;
      resultMessage = success ? (
        <Text color="success">
          <CircularProgress size={12} color={COLOR.success} /> เพิ่มวิชาสอบเรียบร้อยแล้ว
          กำลังเข้าหน้าผลสอบ...
        </Text>
      ) : (
        <Text color="danger">
          <Icon name="error" iconStyle={{ lineHeight: '0.9em' }} /> {message || errorText}
        </Text>
      );
    }
    return (
      <Wrapper>
        {landing && (
          <Text color="primary" fontSize={FONT_SIZE.large} mb={SPACE.medium} textAlign="center">
            ถ้าน้องเคยเชื่อมผลสอบแล้ว{' '}
            <Link
              is="a"
              onClick={onOverviewClick}
              alt="Mock Exam"
              color="inherit"
              fontSize="inherit"
              underline
              hoverColor={COLOR.darkPrimary}
            >
              คลิกที่นี่เพื่อดูผลสอบ
            </Link>
          </Text>
        )}

        <Text
          color="greyscale.grey2" // fontSize={FONT_SIZE.medium}
          mb={SPACE.small}
          textAlign="center"
          mt={SPACE.small}
        >
          <span style={{ textDecoration: 'underline' }}>คำเตือน</span>{' '}
          รหัสนี้กรอกได้เพียงครั้งเดียวเท่านั้น{' '}
          <Text fontWeight="bold" is="span">
            ห้ามใช้รหัสของคนอื่นนะ
          </Text>
        </Text>
        <Form ref={this.form} onValidSubmit={this.handleSubmit} onChange={this.handleFormChange}>
          <Text is="label" style={{ fontWeight: 500, display: 'inline-block' }} mt={SPACE.medium}>
            รหัสที่ได้รับจากอีเมล หรือ SMS
          </Text>
          <Input
            name="code"
            action={{
              content: 'เชื่อมรหัส',
              primary: true,
            }}
            required
            placeholder="เช่น TCASter7UOpqWt"
            disabled={disabled}
            errorLabel={errorLabel}
            validationErrors={{
              isDefaultRequiredValue: 'กรุณากรอกรหัส',
            }}
            value={defaultValue}
            // ref={this.input}
          />
        </Form>
        <Box p={SPACE.small} style={{ alignSelf: 'flex-start' }}>
          {resultMessage}
        </Box>
        <Link
          color="info"
          fontSize={FONT_SIZE.semilarge}
          textAlign={'center'}
          mt={SPACE.medium}
          onClick={onClickLink}
        >
          สมัครสอบ TCASter MOCK Exam ได้ที่นี่
        </Link>
      </Wrapper>
    );
  }
}

export default RedeemForm;
